(()=>{
  const SCALE=2.3;
  const clamp=(value,min,max)=>Math.min(max,Math.max(min,value));

  const reset=button=>{
    if(!button)return;
    const img=button.querySelector('img');
    if(!img)return;
    img.style.transform='matrix(1,0,0,1,0,0)';
    button.classList.remove('is-kpr-inline-zoomed');
    button.setAttribute('aria-label',button.dataset.kprZoomLabel||'Enlarge image');
    const cue=button.querySelector('.kpr-gallery-zoom-cue');
    if(cue)cue.textContent='⌕';
  };

  const resetOthers=current=>{
    document.querySelectorAll('[data-kpr-zoom].is-kpr-inline-zoomed').forEach(button=>{
      if(button!==current)reset(button);
    });
  };

  const zoomAt=(button,event)=>{
    const img=button.querySelector('img');
    if(!img)return;
    const rect=button.getBoundingClientRect();
    if(!rect.width||!rect.height)return;

    if(!button.dataset.kprZoomLabel)button.dataset.kprZoomLabel=button.getAttribute('aria-label')||'Enlarge image';

    /* Load the existing 2400px Shopify source only when zoom is requested. */
    if(button.dataset.fullSrc&&img.dataset.kprInlineHd!=='true'){
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src=button.dataset.fullSrc;
      img.dataset.kprInlineHd='true';
    }

    let x=event.clientX-rect.left;
    let y=event.clientY-rect.top;
    if(!Number.isFinite(x)||!Number.isFinite(y)||event.detail===0){
      x=rect.width/2;
      y=rect.height/2;
    }
    x=clamp(x,0,rect.width);
    y=clamp(y,0,rect.height);

    /* Map the exact clicked pixel toward the center, while clamping at image edges. */
    const scaledWidth=rect.width*SCALE;
    const scaledHeight=rect.height*SCALE;
    const minX=rect.width-scaledWidth;
    const minY=rect.height-scaledHeight;
    const tx=clamp((rect.width/2)-(x*SCALE),minX,0);
    const ty=clamp((rect.height/2)-(y*SCALE),minY,0);

    resetOthers(button);
    img.style.transform=`matrix(${SCALE},0,0,${SCALE},${tx},${ty})`;
    button.classList.add('is-kpr-inline-zoomed');
    button.setAttribute('aria-label','Reset image zoom');
    const cue=button.querySelector('.kpr-gallery-zoom-cue');
    if(cue)cue.textContent='−';
  };

  /* Capture phase blocks the old full-screen lightbox handler without rewriting the gallery. */
  document.addEventListener('click',event=>{
    const button=event.target.closest?.('[data-kpr-zoom]');
    if(!button)return;
    event.preventDefault();
    event.stopPropagation();
    if(button.classList.contains('is-kpr-inline-zoomed'))reset(button);
    else zoomAt(button,event);
  },true);

  /* Changing product views should always return the previous image to normal scale. */
  document.addEventListener('click',event=>{
    if(event.target.closest?.('[data-kpr-main-prev],[data-kpr-main-next],[data-kpr-thumb]')){
      document.querySelectorAll('[data-kpr-zoom].is-kpr-inline-zoomed').forEach(reset);
    }
  },true);

  document.addEventListener('keydown',event=>{
    if(event.key==='Escape')document.querySelectorAll('[data-kpr-zoom].is-kpr-inline-zoomed').forEach(reset);
  });
})();
